import { encode, decode } from 'cbor-x';

// Magic header for binary capsules
export const MAGIC = new Uint8Array([0x4A, 0x53, 0x43, 0x32]); // "JSC2" (Object Capsule v2)
export const VERSION = 2;

// Base64url encoding/decoding utilities
export function base64urlEncode(buffer) {
  // Process in chunks to avoid call stack overflow for large buffers
  const chunkSize = 8192; // Process 8KB at a time
  let binaryString = '';
  
  for (let i = 0; i < buffer.length; i += chunkSize) {
    const chunk = buffer.slice(i, i + chunkSize);
    binaryString += String.fromCharCode(...chunk);
  }
  
  return btoa(binaryString)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
}

export function base64urlDecode(str) {
  const base64 = str
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  
  // Add padding if needed
  const padded = base64 + '='.repeat((4 - base64.length % 4) % 4);
  const binaryString = atob(padded);
  
  // Convert to Uint8Array efficiently for large strings
  const result = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    result[i] = binaryString.charCodeAt(i);
  }
  return result;
}

// Simple checksum calculation
export function calculateChecksum(buffer) {
  let checksum = 0;
  for (let i = 0; i < buffer.length; i++) {
    checksum = ((checksum << 5) - checksum + buffer[i]) >>> 0; // Ensure positive 32-bit
  }
  return checksum;
}

// Binary encoding utilities for capsule header
export function writeUint32(value, buffer, offset = 0) {
  const view = new DataView(buffer.buffer, buffer.byteOffset + offset, 4);
  view.setUint32(0, value, true); // little-endian
  return offset + 4;
}

export function readUint32(buffer, offset = 0) {
  const view = new DataView(buffer.buffer, buffer.byteOffset + offset, 4);
  return view.getUint32(0, true); // little-endian
}

export function writeUint16(value, buffer, offset = 0) {
  const view = new DataView(buffer.buffer, buffer.byteOffset + offset, 2);
  view.setUint16(0, value, true); // little-endian
  return offset + 2;
}

export function readUint16(buffer, offset = 0) {
  const view = new DataView(buffer.buffer, buffer.byteOffset + offset, 2);
  return view.getUint16(0, true); // little-endian
}

export function writeUint8(value, buffer, offset = 0) {
  buffer[offset] = value;
  return offset + 1;
}

export function readUint8(buffer, offset = 0) {
  return buffer[offset];
}

// Object encoding using cbor-x
export function encodeObject(obj) {
  return encode(obj);
}

export function decodeObject(buffer) {
  const obj = decode(buffer);
  return [obj, buffer.length];
}